import { rowsIgnoringDates } from '../amStore';
import { sortedMonths } from '../amMetrics';
import { monthLabel } from '../amRules';

const prevMonthKey = (key) => {
  const [y, m] = key.split('-').map(Number);
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`;
};

/**
 * Previous-period comparison: latest dispatch month in the current selection
 * vs the month before it, with all non-date filters held.
 */
export function monthComparison(s, rows) {
  const months = sortedMonths(rows);
  if (!months.length) return null;
  const cur = months[months.length - 1];
  const prev = prevMonthKey(cur);
  const base = rowsIgnoringDates(s);
  const curRows = base.filter((r) => r.month === cur);
  const prevRows = base.filter((r) => r.month === prev);
  if (!prevRows.length) return null;
  return {
    cur, prev, curRows, prevRows,
    label: `${monthLabel(cur).slice(0, 3)} vs ${monthLabel(prev).slice(0, 3)}`,
  };
}

export const DIM_FILTER = {
  transporter: 'transporter', lane: 'lane', srcCity: 'origin', dstCity: 'dstCity',
  dstZone: 'dstZone', dstState: 'dstState', month: 'month', org: 'org', vehicle: 'vehicle',
  entity: 'entity', primSec: 'primSec', type: 'type', tptCat: 'tptCat',
};
